import React from "react";
import {
    Grid,
    List,
    ListItem,
    ListItemText,
    makeStyles, Paper
} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";

let skeletonHeight = 20;

const useStyles = makeStyles(theme => ({

    infoContainer: {
        // margin: theme.spacing(2),
        height: '100%'
    },
    headerOtherInfo: {
        // textAlign: 'end'
    }
}));
const InvoiceHeader = (props) => {
    const {
        header,
        loading,
        displayPriceField
    } = props;
    const classes = useStyles();
    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} >
                    <Paper className={classes.infoContainer}>
                        <List dense>
                            <ListItem>
                                {
                                    loading ? (
                                            <Skeleton animation='wave' height={skeletonHeight} width='80%'
                                                      style={{marginBottom: 6}}/>
                                        ) :

                                        <ListItemText primary={`Customer name: ${header.customerName}`}/>
                                }
                            </ListItem>

                            <ListItem>
                                {
                                    loading ? <Skeleton animation='wave' height={skeletonHeight} width='40%'
                                                        style={{marginBottom: 6}}/> :

                                        <ListItemText primary={`Customer code: ${header.customerCode}`}/>}
                            </ListItem>
                        </List>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.infoContainer}>
                        <List dense={true}>
                            <ListItem className={classes.headerOtherInfo}>
                                {displayPriceField && (loading ?
                                    <Skeleton animation='wave' height={skeletonHeight} width='40%'
                                              style={{marginBottom: 6}}/>
                                    :
                                    <ListItemText primary={`Invoice total: ${header.formattedNett}`}/>)
                                }
                            </ListItem>

                            <ListItem className={classes.headerOtherInfo}>
                                {loading ?
                                    <Skeleton animation='wave' height={skeletonHeight} width='60%'
                                              style={{marginBottom: 6}}/>
                                    :
                                    <ListItemText primary={`Invoice number: ${header.invoiceNumber}`}/>}
                            </ListItem>
                            <ListItem className={classes.headerOtherInfo}>
                                {loading ?
                                    <Skeleton animation='wave' height={skeletonHeight} width='60%'
                                              style={{marginBottom: 6}}/> :
                                    <ListItemText primary={`Invoice date: ${header.formattedInvoiceDate}`}/>}
                            </ListItem>
                        </List>
                    </Paper>
                </Grid>
            </Grid>

        </div>

    )
}
export default InvoiceHeader;
